import React, { Component } from 'react'
import { format } from 'date-fns'
import UnitStatus from '../enums/UnitStatus'
import UnitStage from '../enums/UnitStage'
import { getAttributeCourseStaticInfo } from './enrolment'

export const unitHasDropDate = unit => {
  return unit && unitWithdrawalDate(unit) !== null
}

export const unitDropDatePassed = unit => {
  return (
    unitHasDropDate(unit) && new Date(unitWithdrawalDate(unit)) < new Date()
  )
}

export const unitDropDateNotPassed = unit => {
  return (
    unitHasDropDate(unit) && new Date(unitWithdrawalDate(unit)) >= new Date()
  )
}

export const unitLocationStartDate = unit => {
  return unit.locationStartDate
    ? new Date(unit.locationStartDate)
    : new Date(unit.availabilityEndDate)
}

export const unitWithdrawalDate = unit => {
  return unit.lastEstudentWdDate !== null
    ? unit.lastEstudentWdDate
    : unit.lastWdDate !== null
    ? unit.lastWdDate
    : unit.availabilityEndDate
}

export const isPlacementUnit = unit => {
  return (
    unit.unitCategoryTypeCode === 'UPL' || unit.unitCategoryTypeCode === 'PPL'
  )
}

export const showUnitDropDateMessage = unit => {
  return (
    unit.virtual !== true &&
    unit.unitStatus === UnitStatus.ENROLLED &&
    unit.unitStage === UnitStage.ENROLLED &&
    isPlacementUnit(unit) &&
    unit.selfWithdrawalFlag &&
    getAttributeCourseStaticInfo('courseSelfManageWithdrawalFlag') === 'Y'
  )
}

export const getDropDateUnitText = unit => {
  if (showUnitDropDateMessage(unit)) {
    if (unitDropDatePassed(unit)) {
      return (
        <p className="unit-drop-date">{`Online withdraw deadline has passed`}</p>
      )
    } else {
      return (
        <p className="unit-drop-date">{`Online withdraw deadline: ${format(
          formatDateLocale(unitWithdrawalDate(unit)),
          'dd MMM yyyy'
        )}`}</p>
      )
    }
  }
}

export const getDropDateUnitTextAddEdit = unit => {
  if (showUnitDropDateMessage(unit)) {
    if (unitDropDatePassed(unit)) {
      return (
        <p className="withdraw-date-label--add-edit">
          {'Online withdraw deadline has passed'}
        </p>
      )
    } else {
      return (
        <p className="withdraw-date-label--add-edit">
          {`Online withdraw deadline: ${format(
            formatDateLocale(new Date(unitWithdrawalDate(unit))),
            'dd MMM yyyy'
          )}`}
        </p>
      )
    }
  }
}

export const formatDateLocale = dateArr => {
  if (dateArr.length === 3) {
    return `${dateArr[0]}/${dateArr[1]}/${dateArr[2]}`
  }
  return dateArr
}
